export const allowedSize = file => {
  const typeFile = file.file.type;
  if (typeFile.includes('image/')) return 5;
  if (typeFile.includes('video/')) return 16;
  if (typeFile.includes('application/')) return 10;

  return 0;
};
